/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Interfaces */
import { DsSynopticsMainItemInterface } from '../interfaces/ds-synoptics-main-item.interface';
/** Models */
import { BydModel } from '@sixense/byd-core-service';
import { DsSynopticsMainItem } from '../models/ds-synoptics-main-item';
/** Functions */
import { BydGenerateParams } from '../../../functions/byd-generate-params.function';

@Injectable({
  providedIn: 'root',
})
export class DsSynopticsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get synoptics for the current project and lane ids and optional work id filter.
   *
   * @param projectId Project ID
   * @param laneIds List of lane ids to query for the synoptics
   * @param workId Optional work id, to filter only on this particualr work
   * @returns Observable type `<BydModel<DsLinearLane[]>>`
   */
  public getSynoptics(
    projectId: number,
    laneIds: number[],
    workId?: number
  ): Observable<BydModel<DsSynopticsMainItem>> {
    this.path = `/v1/projects/${projectId}/synoptics`;
    const params = BydGenerateParams({ laneIds, workId });
    return this.getModels<DsSynopticsMainItem>({ params });
  }

  /**
   * Create DsSynopticsMainItem instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsSynopticsMainItem` instance.
   */
  public createNewInstance(jsonObject: DsSynopticsMainItemInterface): DsSynopticsMainItem {
    return new DsSynopticsMainItem(jsonObject);
  }
}
